import { ButtonVariantProps, buttonVariants } from 'app/theme/button';
import { cn } from 'app/utils/styles.utils';
import { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react';


export type ButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> &
  ButtonVariantProps;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({className, children, variant, size, ...props}, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          buttonVariants({
            variant,
            size,
          }),
          className,
        )}
        {...props}>
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';
